import type { TrackRoleType } from '~/modules/artist-roster/hooks/useReleasesUrlParams/types';

import type { ContributorTypeFilter } from '../types';

/**
 * Formats the contributor role to a string representation.
 *
 * @param {TrackRoleType} role - The role of the contributor.
 * @return {ContributorTypeFilter | undefined} - Returns 'PRIMARY_ARTIST' for 'main', 'FEATURED_ARTIST' for 'featured', or undefined if no role is provided.
 */
export function formatContributorRole(
  role?: TrackRoleType,
): ContributorTypeFilter | undefined {
  if (!role) {
    return undefined;
  }

  switch (role) {
    case 'main':
      return 'PRIMARY_ARTIST';
    case 'featured':
      return 'FEATURED_ARTIST';
  }
}
